import { Link, useForm, Head } from '@inertiajs/react';
import React from 'react';
import useRoute from '@/Hooks/useRoute';
import ContainerAuthForm from '@/Components/Containers/ContainerAuthForm';
import Button from '@/Components/Buttons/Button';
import Input from '@/Components/Inputs/Input';
import ValidationErrors from '../../Components/Utility/ValidationErrors';

export default function ForgotPassword({ status }) {
  const route = useRoute();
  const form = useForm({
    email: '',
  });

  function onSubmit(e) {
    e.preventDefault();
    form.post(route('password.email'));
  }

  return (
    <ContainerAuthForm>
      <Head title="Forgot Password" />

      <div className="mb-4 text-sm text-gray-600">
        Forgot your password? No problem. Just let us know your email address
        and we will email you a password reset link that will allow you to
        choose a new one.
      </div>

      {status && (
        <div className="mb-4 text-sm font-medium text-success">{status}</div>
      )}

      <ValidationErrors />

      <form onSubmit={onSubmit}>
        <div>
          <Input
            id="email"
            type="email"
            label="Your Email"
            className="mt-1 block w-full"
            value={form.data.email}
            onChange={e => form.setData('email', e.currentTarget.value)}
            required
            autoFocus
          />
        </div>

        <div className="mt-4 flex flex-col items-center justify-between">
          <Button disabled={form.processing} type="submit" style="admin">
            <p className="w-full text-base">Email Password Reset Link</p>
          </Button>
          <Link href={route('login')}>
            <Button style="underline">
              <p className="mt-4 text-sm">Login?</p>
            </Button>
          </Link>
        </div>
      </form>
    </ContainerAuthForm>
  );
}
